import {getUsername, getProject} from '../_shared/GWTBridge/invoke/genPage';
import {getPriorityServer} from '../_shared/GWTBridge/invoke/common';
import {monitor as monitoring} from '@priority-software/priority-utils/lib';
import {formsStore} from '../_legacy/Form/stores/FormsStore';
import {getCountry, getLangTitle, getProjType} from '../Localization';

export function sendMonitor(transaction, transactionResult?, field?, formName?, session?) {
    const username = getUsername();
    const project = getProject();
    const projtype = getProjType();
    const priorityserver = getPriorityServer();
    const uilang = getLangTitle();
    const country = getCountry();
    const {currentForm, currentSession} = formsStore;

    monitoring.monitor({
        username: username,
        transaction: transaction,
        transactionResult: transactionResult,
        session: session || currentSession,
        formname: formName || (currentForm && currentForm.name),
        fieldname: field,
        project,
        priorityserver,
        uilang,
        country,
        projtype
    });
}

export function sendMonitorSearchResults(transaction, queryResultsCounter?, field?, formName?) {
    // queryResultsCounter holds the number of records that returned from the server
    // it is beeing called from monitorSearchResults function under NetForm.java
    const username = getUsername();
    const project = getProject();
    const projtype = getProjType();
    const priorityserver = getPriorityServer();
    const uilang = getLangTitle();
    const country = getCountry();
    const {currentForm, currentSession} = formsStore;

    monitoring.monitor({
        username: username,
        transaction: transaction,
        clienttime: queryResultsCounter,
        session: currentSession,
        formname: formName || (currentForm && currentForm.name),
        fieldname: field,
        project,
        priorityserver,
        uilang,
        country,
        projtype
    });
}

export function sendAbortMonitor(transaction, transactionResult, time) {
    const username = getUsername();
    const project = getProject();
    const projtype = getProjType();
    const priorityserver = getPriorityServer();
    const uilang = getLangTitle();
    const country = getCountry();
    const {currentForm, currentSession} = formsStore;

    if (!currentSession) return;

    monitoring.monitor({
        username: username,
        transaction: transaction,
        transactionResult: transactionResult,
        session: currentSession,
        formname: currentForm && currentForm.name,
        fieldname: '',
        project,
        priorityserver,
        networktime: time,
        uilang,
        country,
        projtype
    });
}

export function sendApiMonitor(
    transaction: string,
    formName: string,
    session: string,
    transactionResult: string,
    field: string,
    dbtime: string,
    apptime: string,
    networktime: string
) {
    const username = getUsername();
    const project = getProject();
    const projtype = getProjType();
    const priorityserver = getPriorityServer();
    const uilang = getLangTitle();
    const country = getCountry();

    monitoring.monitor({
        username: username,
        transaction: transaction,
        transactionResult: transactionResult,
        session: session,
        formname: formName,
        fieldname: field,
        project,
        priorityserver,
        dbtime,
        apptime,
        networktime,
        uilang,
        country,
        projtype
    });
}

export function sendAnalyticsMonitor(transaction, transactionResult?, reportName?) {
    const username = getUsername();
    const project = getProject();
    const projtype = getProjType();
    const priorityserver = getPriorityServer();
    const uilang = getLangTitle();
    const country = getCountry();

    monitoring.monitor({
        username: username,
        transaction: transaction,
        transactionResult: transactionResult,
        formname: 'analytics', //maybe move to consts
        fieldname: reportName,
        project,
        priorityserver,
        uilang,
        country,
        projtype
    });
}
